import IconCalendarDaysSolid from '@/assets/icons/font_awesome/calendar-days-solid.svg?react';
import IconCreditCardSolid from '@/assets/icons/font_awesome/credit-card-solid.svg?react';
import IconFaucetSolid from '@/assets/icons/font_awesome/faucet-solid.svg?react';
import IconInvoiceDollarSolid from '@/assets/icons/font_awesome/file-invoice-dollar-solid.svg?react';
import IconGearsSolid from '@/assets/icons/font_awesome/gears-solid.svg?react';
import IconMoneyBillTransferSolid from '@/assets/icons/font_awesome/money-bill-transfer-solid.svg?react';
import IconReceiptSolid from '@/assets/icons/font_awesome/receipt-solid.svg?react';
import IconSharedNodesSolid from '@/assets/icons/font_awesome/share-nodes-solid.svg?react';
import IconUserPlusSolid from '@/assets/icons/font_awesome/user-plus-solid.svg?react';
import { ICON__lock } from '@/assets/icons_fa';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { SidebarWrapper } from '../../_base/SidebarWrapper';
import { TopbarInfoWrapper } from '../../_base/TopbarInfoWrapper';
import { SEPARATOR__horizontal_dashed } from '../../_base/separators/SEPARATOR__horizontal_dashed';
import { SidebarNavigationDesktop } from '../../_base/sidebar_navigation/desktop/SidebarNavigationDesktop';
import { ButtonSettingsWorkspaceTab } from './ButtonSettingsWorkspaceTab';
import { ESettingsWorkspaceTab } from './ESettingsWorkspaceTab';
import { TabSettingsWorkspaceCreditsLimits } from './credits_limits/TabSettingsWorkspaceCreditsLimits';
import { TabSettingsWorkspaceCreditsStatistics } from './credits_statistics/TabSettingsWorkspaceCreditsStatistics';
import { TabSettingsWorkspaceCreditsTopUp } from './credits_top_up/TabSettingsWorkspaceCreditsTopUp';
import { TabSettingsWorkspaceCreditsTransactions } from './credits_transactions/TabSettingsWorkspaceCreditsTransactions';
import { TabSettingsWorkspaceFeaturesAccess } from './features_access/TabSettingsWorkspaceFeaturesAccess';
import { TabSettingsWorkspaceGeneralEdit } from './general_edit/TabSettingsWorkspaceGeneralEdit';
import { TabSettingsWorkspaceGeneralReadOnly } from './general_readonly/TabSettingsWorkspaceGeneralReadOnly';
import { TabSettingsWorkspaceInvoices } from './invoices/TabSettingsWorkspaceInvoices';
import { TabSettingsWorkspaceSharedEntities } from './shared_entities/TabSettingsWorkspaceSharedEntities';
import { TabSettingsWorkspaceSubscription } from './subscription/TabSettingsWorkspaceSubscription';
import { TabSettingsWorkspaceUserInvitationsPersonal } from './user_invitation/TabSettingsWorkspaceUserInvitationsPersonal';
import { TabSettingsWorkspaceUserInvitationsShared } from './user_invitation/TabSettingsWorkspaceUserInvitationsShared';

export function PageSettingsWorkspaceViewsDesktop() {
  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);
  const is_user_owner_of_workspace = workspace_current.user_id_owner == current_workspace_user.user_id;

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * RENDERS
   */
  function render_buttons_for_owner() {
    if (!is_user_owner_of_workspace) return <></>;

    return (
      <>
        <SEPARATOR__horizontal_dashed />
        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.USERS} Icon={IconUserPlusSolid} />

        {!workspace_current.is_personal && <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.FEATURES_ACCESS} Icon={ICON__lock} />}

        {current_workspace_user.is_sharing_permitted() && (
          <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.SHARED_ENTITIES} Icon={IconSharedNodesSolid} />
        )}

        <SEPARATOR__horizontal_dashed />

        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.CREDITS_TRANSACTIONS} Icon={IconMoneyBillTransferSolid} />
        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.CREDITS_STATISTICS} Icon={IconReceiptSolid} />
        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.CREDITS_LIMITS} Icon={IconFaucetSolid} />

        <SEPARATOR__horizontal_dashed />

        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.CREDITS_TOP_UP} Icon={IconCreditCardSolid} />
        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.SUBSCRIPTION} Icon={IconCalendarDaysSolid} />
        <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.INVOICES} Icon={IconInvoiceDollarSolid} />
      </>
    );
  }

  /*
   * HTML
   */
  return (
    <div className="w-full relative flex h-screen text-center ">
      <SidebarNavigationDesktop />
      <SidebarWrapper>
        <TopbarInfoWrapper>
          <span className="w-full text-center">{`${t(i18n_page_settings_workspace.page_title)}: ${workspace_current.name}`}</span>
        </TopbarInfoWrapper>
        <div className="flex flex-col gap-0  overflow-y-auto bg-component  pt-2">
          <ButtonSettingsWorkspaceTab type={ESettingsWorkspaceTab.GENERAL} Icon={IconGearsSolid} />

          {render_buttons_for_owner()}
        </div>
      </SidebarWrapper>

      <TabSettingsWorkspaceGeneralEdit />
      <TabSettingsWorkspaceGeneralReadOnly />

      <TabSettingsWorkspaceSharedEntities />

      <TabSettingsWorkspaceUserInvitationsPersonal />
      <TabSettingsWorkspaceUserInvitationsShared />

      <TabSettingsWorkspaceFeaturesAccess />

      <TabSettingsWorkspaceCreditsTransactions />
      <TabSettingsWorkspaceCreditsStatistics />
      <TabSettingsWorkspaceCreditsLimits />

      <TabSettingsWorkspaceCreditsTopUp />
      <TabSettingsWorkspaceInvoices />
      <TabSettingsWorkspaceSubscription />
    </div>
  );
}
